document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.hero__slider');

    if (slider) {
        const swiper = new Swiper(slider, {
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: slider.querySelector('.slider-prev-button'),
                prevEl: slider.querySelector('.slider-next-button'),
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: true,
            },
            on: {
                slideChange: function () {
                    const currentSlide = this.slides[this.activeIndex];
                    const slideNumber = currentSlide.getAttribute('data-slide-number');
                    console.log(`Slide changed to ${slideNumber}`);
                    document.querySelectorAll('div[id^="hero__image-wrapper-"]').forEach((div) => {
                        if (div.id === `hero__image-wrapper-${slideNumber}`) {
                            div.classList.add('active');
                        } else {
                            div.classList.remove('active');
                        }
                    });
                },
            },
        });
    }
});